import type { AxiosError } from 'axios'
import { FEATURE_FLAGS } from '../../feature-flag'
import { globalUtils } from '@gat-ship/utils'

export const appSessionId = globalUtils.functions.uuid()

export function getBaseApiUrl() {
  // Production
  if (FEATURE_FLAGS.IS_PROD) {
    return import.meta.env.VITE_API_URL
  }
  // Staging
  if (FEATURE_FLAGS.IS_STAGING) {
    return import.meta.env.VITE_API_URL
  }
  // Development
  return '/api/'
}

export function catchApiError<T, U>(
  promsie: Promise<T>,
  options?: { defaultErrorHandling?: boolean }
): Promise<[undefined, T] | [U]> {
  return promsie
    .then((data) => {
      return [undefined, data] as [undefined, T]
    })
    .catch((error: AxiosError) => {
      const problemDetails = error?.response?.data
      if (typeof problemDetails === 'string' && problemDetails.length === 0) {
        // If the problem details is an empty string, return the error
        return [error] as [U]
      }
      return [problemDetails ?? error] as [U]
    })
}
